import { CanActivateFn, Router } from '@angular/router';
import {inject} from "@angular/core";
import {select, Store} from "@ngrx/store";
import {combineLatest} from "rxjs";
import {selectUserPermissions} from "../../../store/selectors";
import { filter, map } from "rxjs/operators";

export const customPageActivateGuard: CanActivateFn = (route, state) => {

  const store = inject(Store);
  const router = inject(Router);
  const customPage = route.data.page; // Access the resolved page

  return combineLatest([store.pipe(select(selectUserPermissions))]).pipe(
    filter(([userPermissions]) => !!userPermissions),
    map( ([userPermissions]) => {
      if (userPermissions.isAdmin) {
        return true;
      }

      if (customPage) {
        const isPublished = customPage?.status === 'published';
        if (isPublished) {
          return true;
        }
      }

      return router.parseUrl('/courses');
    })
  );
};
